import styled from 'styled-components';
import { Text15Bold, Text15Light } from '../../../components/utils/Text/Text.styles';
import { Button } from '../../../components/utils/Button/Button';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 76rem;
  padding: 2.4rem 0;
  height: 100%;

  @media only screen and (max-width: 760px) {
    padding: 1.6rem 1.2rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 42rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 0.4rem;
  align-items: center;
`;

export const Line = styled.div`
  border-radius: 100px;
  background: var(--Stroke-Darker, #d2d6db);
  height: 2px;
  width: 1.6rem;
`;

export const Text = styled(Text15Light)`
  line-height: 2.9rem;
  letter-spacing: -0.408px;
  margin-bottom: 2.4rem;
`;

export const Title = styled(Text15Bold)`
  margin-bottom: 1rem;
`;

export const StyledButton = styled(Button)`
  margin-top: 3.2rem;
  width: 24rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
    width: 100%;
  }
`;
